import {ResolveFn, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {inject} from '@angular/core';
import {map, switchMap, tap} from 'rxjs/operators';
import {of} from "rxjs";
import {CurrentTitleService} from "../services/title/current-title.service";

const TRANSLATION_PREFIX = 'pageTitle.';

export const appTitleResolver = (title: string, defaultTitle: string = 'default'): ResolveFn<void> => (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const titleService = inject(Title);
  const translate = inject(TranslateService);
  const currentTitleService = inject(CurrentTitleService);

  let key = `${TRANSLATION_PREFIX}${title}`;
  currentTitleService.setTitleWithKey(key);

  return translate.get(key).pipe(
    map(translated => {
      if (translated === `${TRANSLATION_PREFIX}${title}`) {
        key = `${TRANSLATION_PREFIX}${defaultTitle}`;
        currentTitleService.setTitleWithKey(key);
        return translate.get(key).pipe(
          map(defaultTranslated => titleService.setTitle(defaultTranslated))
        );
      } else {
        titleService.setTitle(translated);
        return of(undefined);
      }
    }),
    switchMap(result => result || of(undefined)) // handle the nested observables
  );
};
